/* Recovery Bundles (sections/sf-recovery-bundles.liquid), 30.09.2026, Fix-Runde nach drei Reviews.
   Mechanik "Option C" (r4/research/mech/mechanics.md):
   - Ein Klick = genau EIN POST /cart/add.js mit allen Zeilen der Karte, je 1 Stueck.
   - Nur sofort lieferbare Ware: Boots oder Kit, PEAK, STARKSHAKE nur als normale Variante des Hauptprodukts,
     wenn es verkaeuflich ist. Nie eine Vorbestellzeile, nie Vorbestell-Eigenschaften.
   - Eigenschaften: _sf_bundle = Bundle-Titel und _sf_bundle_id (Token dieses Klicks) auf allen Zeilen,
     PEAK-Zeilen zusaetzlich _sf_peak = 1 (neutral fuer assets/stl-order-type-guard.js).
   - Vorher: Guard-Vorpruefung (Stand der Seite, dann frisch per stlOrderTypeGuard.refresh()) und frische
     Pruefung von Bestand und Preis.
   - Nachher: Antwort pruefen. Vollstaendig (200) = sofort zur Warenkorbseite (cartType "page"), Button bleibt
     bis zum Seitenwechsel belegt. Sonst /cart.js lesen, nur die Zeilen dieses Klicks zuruecknehmen und danach
     erneut lesen; "unveraendert" nur, wenn der Warenkorb das belegt.
   - Groessen-Tipp oeffnet den vorhandenen Groessenfinder der Seite per host.open() (kein sf:set-apply,
     damit die Buybox unberuehrt bleibt). */
(function () {
  'use strict';
  if (window.__sfrbInit) return;
  window.__sfrbInit = true;

  var T = {
    add: 'In den Warenkorb',
    busy: 'Wird hinzugefügt',
    pickSize: function (n) { return 'Größe für ' + n + ' wählen'; },
    soldout: 'Nicht alles verfügbar',
    soldoutMeta: 'Gerade ausverkauft',
    locked: 'Nur in Deutschland bestellbar',
    guard: 'Vorbestellungen und sofort verfügbare Artikel müssen getrennt bestellt werden.',
    stale: 'Deine Auswahl ist gerade nicht mehr vollständig lieferbar. Bitte wähle neu.',
    priceChanged: 'Ein Preis hat sich gerade geändert. Bitte prüfe die Summe und klicke noch einmal.',
    notOrderable: 'Das Bundle ist gerade nicht bestellbar. Bitte versuch es später noch einmal.',
    rolledBack: 'Das Bundle konnte nicht vollständig in den Warenkorb gelegt werden. Dein Warenkorb ist unverändert.',
    partial: 'Das Bundle liegt nur teilweise im Warenkorb. Bitte prüfe deinen Warenkorb.',
    unknown: 'Wir konnten nicht prüfen, ob das Bundle im Warenkorb liegt. Bitte prüfe deinen Warenkorb, bevor du es noch einmal versuchst.',
    network: 'Das hat nicht geklappt. Bitte versuch es noch einmal.'
  };

  /* Geld im Format der Seite ("€902,06"); andere Waehrungen per Intl mit der aktiven Waehrung */
  var intl = null;
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    if (cur === 'EUR') return '€' + (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    try {
      if (!intl) intl = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: cur });
      return intl.format(c / 100);
    } catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  function root() {
    var r = window.Shopify && Shopify.routes && Shopify.routes.root;
    return typeof r === 'string' && /^\/(?:[a-zA-Z-]+\/)*$/.test(r) ? r : '/';
  }
  function getJson(url) {
    return window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('request_failed'); return r.json(); });
  }
  function postJson(url, body) {
    return window.fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
  }
  function userError(msg) { var e = new Error(msg); e.userMessage = msg; return e; }
  function token() { return 'rb' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  /* ------------------------------------------------------------ Auswahl lesen */
  function items(card) { return [].slice.call(card.querySelectorAll('[data-sfrb-item]')); }
  function kind(item) { return item.getAttribute('data-kind'); }
  function mainItem(card) { return card.querySelector('[data-sfrb-item][data-kind="main"]'); }

  /** gewaehlte Variante einer Zeile als {id, cents, compare, img, unit, input} oder null */
  function picked(item) {
    if (item.hasAttribute('data-soldout')) return null;
    var el = item.querySelector('input[type="radio"]:checked:not(:disabled)') || item.querySelector('input[data-sfrb-fixed]');
    if (!el) return null;
    return { id: el.value, cents: num(el.getAttribute('data-cents')), compare: num(el.getAttribute('data-compare')), img: el.getAttribute('data-img'), unit: el.getAttribute('data-unit'), input: el };
  }
  /** Zeile geht in den Warenkorb? Shaker nur im Modus "live" */
  function counts(item) { return kind(item) !== 'shaker' || item.getAttribute('data-mode') === 'live'; }

  function state(card) {
    var st = { total: 0, extra: 0, needSize: false, soldout: false, lines: [], mainName: '' };
    items(card).forEach(function (it) {
      var k = kind(it);
      var p = picked(it);
      if (k === 'main') st.mainName = it.getAttribute('data-name') || 'STARKBOOTS';
      if (!counts(it)) return;
      var peak = it.getAttribute('data-peak') === '1';
      if (!p) {
        if (k === 'main' && !it.hasAttribute('data-soldout') && it.querySelector('input[data-sfrb-size]:not(:disabled)')) st.needSize = true;
        else st.soldout = true;
        // Summe bleibt die des ganzen Bundles (angezeigter Preis der Zeile), nie eine Teilsumme
        var show = num(it.getAttribute('data-show-cents'));
        st.total += show;
        return;
      }
      st.total += p.cents;
      if (p.compare > p.cents) st.extra += p.compare - p.cents;
      st.lines.push({ item: it, kind: k, handle: it.getAttribute('data-handle'), id: p.id, cents: p.cents, peak: peak });
    });
    return st;
  }

  /* ------------------------------------------------------------ Anzeige */
  function syncItem(it) {
    var p = picked(it);
    if (!p) return;
    var price = it.querySelector('[data-sfrb-price]');
    if (price) price.textContent = money(p.cents);
    it.setAttribute('data-show-cents', String(p.cents));
    var unit = it.querySelector('[data-sfrb-unit]');
    if (unit && p.unit) unit.textContent = p.unit;
    var img = it.querySelector('img.sfrb-item__img');
    // Bild nur nach echtem Variantenwechsel tauschen (srcset der Erstanzeige bleibt)
    if (img && p.img && it.getAttribute('data-img-now') !== p.img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = p.img;
      it.setAttribute('data-img-now', p.img);
    }
    if (kind(it) === 'shaker') {
      var link = it.querySelector('[data-sfrb-pre-link]');
      var base = it.getAttribute('data-url');
      if (link && base) link.setAttribute('href', base + '?variant=' + encodeURIComponent(p.id));
      var cname = p.input.getAttribute('data-label') || '';
      if (cname) it.querySelectorAll('[data-sfrb-color-name]').forEach(function (n) { n.textContent = cname; });
      // Link als ein Textknoten, sonst unterstreicht sfui-btn-link Farbe und Rest getrennt
      if (cname && link && link.hasAttribute('data-suffix')) link.textContent = cname + link.getAttribute('data-suffix');
    }
  }

  function sync(card) {
    items(card).forEach(syncItem);
    var st = state(card);
    var sec = card.closest('[data-sfrb]');
    var freeMin = num(sec && sec.getAttribute('data-peak-free')) || 5000;

    var sum = card.querySelector('[data-sfrb-sum]');
    if (sum) sum.textContent = money(st.total);
    var was = card.querySelector('[data-sfrb-was]');
    var save = card.querySelector('[data-sfrb-save]');
    var real = st.extra > 0 && !st.needSize && !st.soldout;
    if (was) { was.hidden = !real; was.textContent = real ? money(st.total + st.extra) : ''; }
    if (save) {
      save.hidden = !real;
      save.textContent = real ? 'Du sparst ' + money(st.extra) + (/Kit/.test(st.mainName) ? ' mit dem Kit' : '') : '';
    }
    var free = st.total >= freeMin;
    var shipTxt = card.querySelector('[data-sfrb-peak-ship-txt]');
    if (shipTxt) shipTxt.textContent = shipTxt.getAttribute(free ? 'data-above' : 'data-below') || shipTxt.textContent;

    var btn = card.querySelector('[data-sfrb-add]');
    var label = btn && btn.querySelector('[data-sfrb-label]');
    if (btn && btn.getAttribute('aria-busy') !== 'true' && !card.__sfrbLeaving) {
      var text, off;
      if (card.getAttribute('data-locked') === 'true') { off = true; text = T.locked; }
      else if (st.soldout) { off = true; text = T.soldout; }
      else if (st.needSize) { off = true; text = T.pickSize(st.mainName); }
      else { off = false; text = T.add + ' · ' + money(st.total); }
      if (off && !btn.disabled && document.activeElement === btn) keepFocus(card);
      btn.disabled = off;
      if (label) label.textContent = text;
    }

    /* Klarna-Zeile dieser Karte: nur bei vollstaendiger, kaufbarer Auswahl und
       immer mit der Summe, die auch auf dem Kaufbutton steht. */
    var scope = card.getAttribute('data-sfrb-scope');
    if (scope) {
      var buyable = !st.needSize && !st.soldout && card.getAttribute('data-locked') !== 'true' && st.total > 0;
      window.dispatchEvent(new CustomEvent('sf:set-total', { detail: { form: scope, ready: buyable, total: st.total } }));
    }
    return st;
  }

  /** Fokus nicht auf <body> fallen lassen, wenn der fokussierte Button gesperrt wird */
  function keepFocus(card) {
    var msg = card.querySelector('[data-sfrb-msg]');
    if (msg && msg.textContent) { msg.setAttribute('tabindex', '-1'); msg.focus({ preventScroll: true }); return; }
    var chip = card.querySelector('input[data-sfrb-size]:not(:disabled)') || card.querySelector('input[type="radio"]:not(:disabled)');
    if (chip) chip.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------ Groessenfinder (vorhandener Host der Seite) */
  function finder() {
    var host = document.querySelector('sf-size-finder');
    return host && typeof host.open === 'function' ? host : null;
  }
  function announce(card, msg) {
    var sec = card.closest('[data-sfrb]');
    var live = sec && sec.querySelector('[data-sfrb-live]');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 80);
  }
  function sizeInput(card, letter) {
    var m = mainItem(card);
    if (!m) return null;
    var L = String(letter || '').trim().charAt(0).toUpperCase();
    return [].filter.call(m.querySelectorAll('input[data-sfrb-size]'), function (el) { return el.getAttribute('data-letter') === L; })[0] || null;
  }
  function openFinder(card, tip) {
    var host = finder();
    var m = mainItem(card);
    if (!host || !m) return;
    var cur = m.querySelector('input[data-sfrb-size]:checked');
    host.open({
      setName: m.getAttribute('data-name') || 'STARKBOOTS',
      unitLabel: '',
      current: cur ? cur.getAttribute('data-letter') : '',
      availability: function (letter) {
        var el = sizeInput(card, letter);
        return { exists: !!el, available: !!el && !el.disabled, label: el ? el.getAttribute('data-label') : '' };
      },
      apply: function (letter) {
        var el = sizeInput(card, letter);
        if (!el) return { ok: false, message: 'Diese Größe gibt es hier nicht.' };
        if (el.disabled) return { ok: false, message: 'Größe ' + el.getAttribute('data-letter') + ' ist gerade nicht verfügbar.' };
        el.checked = true;
        card.__sfrbTouched = true;
        sync(card);
        return { ok: true, letter: el.getAttribute('data-letter'), label: el.getAttribute('data-label') };
      },
      restoreFocus: function (applied) {
        if (tip) tip.focus({ preventScroll: true });
        if (!applied) return;
        announce(card, 'Größe ' + applied.letter + ' für ' + (card.getAttribute('data-title') || 'das Bundle') + ' übernommen.');
        if (tip) {
          tip.classList.add('is-done');
          setTimeout(function () { tip.classList.remove('is-done'); }, 2400);
        }
        var el = m.querySelector('input[data-sfrb-size]:checked');
        var face = el && el.nextElementSibling;
        if (face) {
          face.classList.add('is-applied');
          setTimeout(function () { face.classList.remove('is-applied'); }, 1200);
        }
      }
    });
  }
  function showTips(scope) {
    var host = finder();
    (scope || document).querySelectorAll('[data-sfrb] [data-sfrb-tip]').forEach(function (tip) {
      tip.hidden = !host;
      if (host && host.id) tip.setAttribute('aria-controls', host.id + '-dialog');
    });
  }

  /* ------------------------------------------------------------ Warenkorb */
  function buildItems(card, st, tok) {
    var name = String(card.getAttribute('data-title') || 'Recovery Bundle');
    return st.lines.map(function (l) {
      var props = { _sf_bundle: name, _sf_bundle_id: tok };
      if (l.peak) props._sf_peak = '1';
      return { id: Number(l.id), quantity: 1, properties: props };
    });
  }
  function guardBlocks(list) {
    var g = window.stlOrderTypeGuard;
    var own = list.some(function (i) { return !(i.properties && i.properties._sf_peak === '1'); });
    return Boolean(g && g.state && g.state.hasPreorder && own);
  }
  function guardMessage() {
    var c = window.__stlOrderTypeGuardConfig;
    return (c && c.message) || T.guard;
  }
  /** Guard-Stand frisch aus /cart.js (Vorbestellung evtl. in einem anderen Tab); hoechstens 4 s warten */
  function refreshGuard() {
    var g = window.stlOrderTypeGuard;
    if (!g || typeof g.refresh !== 'function') return Promise.resolve();
    return Promise.race([
      Promise.resolve().then(function () { return g.refresh(); }).catch(function () {}),
      new Promise(function (r) { setTimeout(r, 4000); })
    ]);
  }
  function freshCheck(card, st) {
    var handles = st.lines.map(function (l) { return l.handle; }).filter(function (h, i, a) { return h && a.indexOf(h) === i; });
    return Promise.all(handles.map(function (h) { return getJson(root() + 'products/' + encodeURIComponent(h) + '.js'); }))
      .then(function (products) {
        var by = {};
        products.forEach(function (p, i) { by[handles[i]] = p; });
        var stale = false, changed = false;
        st.lines.forEach(function (l) {
          var p = by[l.handle];
          var live = p && (p.variants || []).filter(function (v) { return String(v.id) === String(l.id); })[0];
          var input = l.item.querySelector('input[value="' + l.id + '"]');
          if (!live || live.available !== true) {
            stale = true;
            if (input && input.type === 'radio') { input.disabled = true; input.checked = false; input.classList.add('disabled'); }
            else {
              l.item.setAttribute('data-soldout', '');
              var meta = l.item.querySelector('[data-sfrb-meta]');
              if (meta) meta.textContent = T.soldoutMeta;
            }
            return;
          }
          if (Number(live.price) !== Number(l.cents)) {
            changed = true;
            if (input) input.setAttribute('data-cents', String(live.price));
          }
        });
        if (stale) throw userError(T.stale);
        if (changed) throw userError(T.priceChanged);
      });
  }
  function linesOf(cart, tok) {
    return (cart && Array.isArray(cart.items) ? cart.items : []).filter(function (l) {
      return l.properties && l.properties._sf_bundle_id === tok;
    });
  }
  function complete(lines, list) {
    return list.every(function (it) {
      return lines.some(function (l) { return String(l.id) === String(it.id) && l.quantity >= it.quantity; });
    });
  }
  /** Zeilen dieses Klicks entfernen und danach nachlesen. Ergebnis {found, left}; wirft, wenn /cart.js nicht lesbar ist. */
  function cleanup(tok) {
    return getJson(root() + 'cart.js').then(function (cart) {
      var lines = linesOf(cart, tok);
      if (!lines.length) return { found: 0, left: 0 };
      return lines.reduce(function (p, l) {
        return p.then(function () {
          return postJson(root() + 'cart/change.js', { id: l.key, quantity: 0 }).catch(function () { return null; });
        });
      }, Promise.resolve()).then(function () {
        return getJson(root() + 'cart.js').then(function (after) {
          return { found: lines.length, left: linesOf(after, tok).length };
        });
      });
    });
  }
  function leave(card, btn) {
    // Button bleibt belegt, bis die Warenkorbseite geladen ist (kein zweites Hinzufuegen per Doppeltipp)
    card.__sfrbLeaving = true;
    btn.setAttribute('aria-busy', 'true');
    var routes = (window.theme && theme.routes) || {};
    window.location.href = routes.cart_url || root() + 'cart';
  }
  function done(card, btn, res) {
    try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res } })); } catch (e) { /* egal */ }
    var drawer = document.querySelector('cart-drawer');
    var pageCart = !(window.theme && theme.settings) || theme.settings.cartType === 'page';
    if (pageCart || !drawer || typeof drawer.show !== 'function') {
      // Warenkorbseite: cartUpdate nur, wenn /cart.js schnell antwortet; der Wechsel haengt nicht davon ab
      return Promise.race([
        getJson(root() + 'cart.js').then(function (cart) { publishCart(cart, res); }).catch(function () {}),
        new Promise(function (r) { setTimeout(r, 1500); })
      ]).then(function () { leave(card, btn); });
    }
    return getJson(root() + 'cart.js').then(function (cart) { publishCart(cart, res); drawer.show(btn); }, function () { leave(card, btn); });
  }
  function publishCart(cart, res) {
    try {
      cart.sections = res && res.sections;
      if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'sf-recovery-bundles', cart: cart });
    } catch (e) { /* Anzeige egal, Warenkorb stimmt */ }
  }

  function add(card, btn) {
    if (btn.getAttribute('aria-busy') === 'true' || card.__sfrbLeaving) return;
    var msg = card.querySelector('[data-sfrb-msg]');
    var say = function (t) { if (msg) { msg.textContent = t || ''; if (!t) msg.removeAttribute('tabindex'); } };
    say('');
    if (card.getAttribute('data-locked') === 'true') return;
    var st = sync(card);
    if (st.needSize) {
      say(T.pickSize(st.mainName) + '.');
      var first = card.querySelector('input[data-sfrb-size]:not(:disabled)');
      if (first) first.focus();
      return;
    }
    if (st.soldout || !st.lines.length) { say(T.stale); return; }

    var tok = token();
    var list = buildItems(card, st, tok);
    if (guardBlocks(list)) { say(guardMessage()); return; }

    var sections = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })); } catch (e) {}
    btn.setAttribute('aria-busy', 'true');
    var label = btn.querySelector('[data-sfrb-label]');
    if (label) label.textContent = T.busy;
    var sent = false;

    Promise.all([freshCheck(card, st), refreshGuard()])
      .then(function () {
        if (guardBlocks(list)) throw userError(guardMessage());
        sent = true;
        var body = { items: list };
        if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
        return postJson(root() + 'cart/add.js', body).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) { j = j || {}; j.__ok = r.ok; return j; });
        });
      })
      .then(function (res) {
        if (res.__ok && !res.status && complete(linesOf(res, tok), list)) return done(card, btn, res);
        // 422 (teils nur {"errors":"Warenkorb-Fehler"}, ohne "status") oder unvollstaendige Antwort
        var reason = res.description && !/Variante nicht finden|Warenkorb-Fehler/i.test(res.description) ? res.description : T.notOrderable;
        return cleanup(tok).then(function (r) {
          if (r.left > 0) throw userError(T.partial);
          throw userError(r.found ? T.rolledBack : reason);
        }, function () {
          // Warenkorb nicht lesbar: 422 ist bei Shopify atomar (nichts hinzugefuegt), 200 unvollstaendig = unklar
          throw userError(res.__ok ? T.unknown : reason);
        });
      })
      .catch(function (err) {
        if (err && err.userMessage) { say(err.userMessage); return; }
        var gm = guardMessage();
        if (err && err.message === gm) { say(gm); return; }
        if (!sent) { say(T.network); return; }
        // Netzfehler waehrend des Hinzufuegens: Ausgang am Warenkorb ablesen
        return getJson(root() + 'cart.js').then(function (cart) {
          var lines = linesOf(cart, tok);
          if (lines.length && complete(lines, list)) return done(card, btn, null);
          if (!lines.length) { say(T.network); return; }
          return cleanup(tok).then(function (r) { say(r.left > 0 ? T.partial : T.rolledBack); }, function () { say(T.unknown); });
        }, function () { say(T.unknown); });
      })
      .then(function () {
        if (card.__sfrbLeaving) return;
        btn.removeAttribute('aria-busy');
        sync(card);
      });
  }

  // Zurueck aus dem Warenkorb (bfcache): Button wieder freigeben
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-sfrb] [data-sfrb-card]').forEach(function (card) {
      if (!card.__sfrbLeaving) return;
      card.__sfrbLeaving = false;
      var btn = card.querySelector('[data-sfrb-add]');
      if (btn) btn.removeAttribute('aria-busy');
      sync(card);
    });
  });

  /* ------------------------------------------------------------ STARKSHAKE: automatisch dazu, sobald verkaeuflich */
  /** Farbwert aus data-swatches ("|Onyx Black=#000000|..."), sonst letztes Wort des Namens (wie das Theme) */
  function swatchColor(box, value) {
    var list = (box && box.getAttribute('data-swatches')) || '';
    var key = '|' + value + '=';
    var at = list.indexOf(key);
    if (at > -1) return list.slice(at + key.length).split('|')[0];
    return String(value || '').split(' ').pop().toLowerCase();
  }
  function colorChip(it, v, name, box) {
    var val = v.option1 || v.title || '';
    var lab = document.createElement('label');
    lab.className = 'sfrb-sw';
    lab.title = val;
    var inp = document.createElement('input');
    inp.type = 'radio';
    inp.name = name;
    inp.value = String(v.id);
    inp.setAttribute('data-sfrb-opt', '');
    inp.setAttribute('data-label', val);
    inp.setAttribute('data-cents', String(v.price));
    inp.setAttribute('data-avail', '1');
    inp.setAttribute('aria-label', val);
    var face = document.createElement('span');
    face.className = 'sfrb-sw__face';
    face.style.setProperty('--sfrb-sw', swatchColor(box, val));
    lab.appendChild(inp);
    lab.appendChild(face);
    return lab;
  }
  function upgradeShaker(card) {
    var it = card.querySelector('[data-sfrb-item][data-kind="shaker"][data-mode="preorder"]');
    if (!it) return;
    var h = it.getAttribute('data-handle');
    getJson(root() + 'products/' + encodeURIComponent(h) + '.js').then(function (p) {
      if (!p || p.available !== true) return;
      var avail = {};
      (p.variants || []).forEach(function (v) { avail[String(v.id)] = v.available === true; });
      var box = it.querySelector('[data-sfrb-colors]');
      var inputs = [].slice.call(it.querySelectorAll('input[data-sfrb-opt]'));
      // Farben, die bisher nicht gezeigt wurden (nicht in der Vorbestell-Liste), aber jetzt lieferbar sind
      if (box) {
        var have = inputs.map(function (el) { return el.value; });
        var name = (inputs[0] && inputs[0].name) || (card.id || 'sfrb') + '-color';
        (p.variants || []).forEach(function (v) {
          if (v.available === true && have.indexOf(String(v.id)) === -1) box.appendChild(colorChip(it, v, name, box));
        });
        inputs = [].slice.call(it.querySelectorAll('input[data-sfrb-opt]'));
      }
      it.setAttribute('data-mode', 'live');
      it.classList.remove('is-separate');
      inputs.forEach(function (el) {
        var ok = !!avail[el.value];
        el.disabled = !ok;
        el.classList.toggle('disabled', !ok);
        if (!ok) el.checked = false;
      });
      if (!it.querySelector('input[data-sfrb-opt]:checked')) {
        var f = inputs.filter(function (el) { return !el.disabled; })[0];
        if (f) f.checked = true;
      }
      it.querySelectorAll('[data-sfrb-pre-note]').forEach(function (n) { n.hidden = true; });
      var ln = it.querySelector('[data-sfrb-live-note]'); if (ln) ln.hidden = false;
      var pr = it.querySelector('[data-sfrb-price]'); if (pr) pr.hidden = false;
      var sub = card.querySelector('[data-sfrb-sub]'); if (sub) sub.textContent = 'Summe der Einzelpreise inkl. MwSt.';
      sync(card);
    }).catch(function () { /* Hinweis bleibt */ });
  }

  /* ------------------------------------------------------------ Groesse aus der Buybox uebernehmen (nur lesen) */
  function setSize(card, label) {
    if (card.__sfrbTouched || !label) return;
    var m = mainItem(card);
    if (!m) return;
    var el = [].filter.call(m.querySelectorAll('input[data-sfrb-size]'), function (x) { return x.getAttribute('data-label') === label; })[0];
    if (!el || el.disabled || el.checked) return;
    el.checked = true;
    sync(card);
  }
  function fromBuybox(scope) {
    var s = window.__sfSetState;
    if (!s) return;
    (scope || document).querySelectorAll('[data-sfrb] [data-sfrb-card]').forEach(function (card) {
      var m = mainItem(card);
      var set = m && s[m.getAttribute('data-name')];
      var u = set && set.units && set.units[0];
      if (u && u.size) setSize(card, u.size);
    });
  }

  /* ------------------------------------------------------------ Verdrahtung */
  function inBundles(t) { return t && t.closest && t.closest('[data-sfrb]'); }

  // sf-buybox.js haelt nach Klicks auf .sfb-size die Scroll-Position fest (Buybox-Schutz); hier nicht gewollt.
  function releaseScrollLock(e) {
    if (!inBundles(e.target)) return;
    window.__sfBuyboxScrollLock = null;
    window.__sfBuyboxPreventMediaScrollUntil = 0;
  }
  document.addEventListener('pointerdown', releaseScrollLock);
  document.addEventListener('click', releaseScrollLock);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (inBundles(t)) {
      var card = t.closest('[data-sfrb-card]');
      if (!card) return;
      if (t.matches('input[data-sfrb-size]')) card.__sfrbTouched = true;
      var msg = card.querySelector('[data-sfrb-msg]'); if (msg) msg.textContent = '';
      sync(card);
      return;
    }
    // Buybox-Chip: "STARKBOOTS V2|0|Medium"
    var key = t && t.getAttribute && t.getAttribute('data-sf-size-input');
    if (!key) return;
    var parts = key.split('|');
    if (parts[1] !== '0') return;
    document.querySelectorAll('[data-sfrb] [data-sfrb-card]').forEach(function (card) {
      var m = mainItem(card);
      if (m && m.getAttribute('data-name') === parts[0]) setSize(card, parts[2]);
    });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!inBundles(t)) return;
    var tip = t.closest('[data-sfrb-tip]');
    if (tip) { e.preventDefault(); openFinder(tip.closest('[data-sfrb-card]'), tip); return; }
    var btn = t.closest('[data-sfrb-add]');
    if (btn) { e.preventDefault(); add(btn.closest('[data-sfrb-card]'), btn); }
  });

  function onVariantChange(payload) {
    var d = payload && payload.data;
    var v = d && d.variant;
    if (!v || !v.option1 || !v.option2) return;
    document.querySelectorAll('[data-sfrb] [data-sfrb-card]').forEach(function (card) {
      var m = mainItem(card);
      if (m && m.getAttribute('data-name') === v.option2) setSize(card, v.option1);
    });
  }

  function init(scope) {
    var cards = (scope || document).querySelectorAll('[data-sfrb] [data-sfrb-card]');
    cards.forEach(function (card) { sync(card); upgradeShaker(card); });
    fromBuybox(scope);
    showTips(scope);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('sf-size-finder').then(function () { showTips(scope); });
    }
  }
  window.sfRecoveryBundles = { init: init, sync: sync };

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  (function subscribe() {
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && theme.pubsub.subscribe) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, onVariantChange);
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', subscribe, { once: true });
    }
  })();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
